@if(appInitializationStatus() === AppInitializationStatus.consoleUp) {
  <header class="app__header">
    <app-header></app-header>
  </header>
  <app-nav-sidebar class="app__content">
    <main class="app__main">
      <router-outlet></router-outlet>
    </main>
  </app-nav-sidebar>
  <footer class="app__footer">
    <app-footer></app-footer>
  </footer>
}
